export const UPDATE_AS_READ_PROCESS_STATEMENT_REQUEST = 'UPDATE_AS_READ_PROCESS_STATEMENT_REQUEST';

export const updateAsReadProcessStatementRequest = ( id ) => ({
    type: UPDATE_AS_READ_PROCESS_STATEMENT_REQUEST,
    payload: { id }
});
